<div class="column-flex">
    <div class="header-container">
        <div class="form-label">
        {{ 'system-settings.eap.led.pattern-setting-dialog.title' | translate }}
        </div>
        <div class="cancel button" (click)="close()">
            {{ 'dlg.close' | translate }}
        </div>
    </div> 

    <div class="main-container">
        <div class="pattern-list">
            <app-button
                class="add-button"
                text="system-settings.eap.led.pattern-setting-dialog.add-pattern"
                (onClick)="addPattern()"
                [iconButton]="true"
                [noneMarginIcon]="true"
                iconSize="20px"
                icon="plus"
                customFontSize="14px"
                customFontFamily="NotoSans-SemiBold"
                [disable]="!data.userCanEdit || this.ledPatternList.length >= 10"
            >
            </app-button>
            <div
                class="pattern-row"
                *ngFor="let pattern of ledPatternList; let i = index"
            >
                <div class="pattern-name">
                    {{ pattern.name }}
                </div>
                <div
                    class="cell options"
                    [class.selected]="isOpenOption && selectedIndex === i"
                >
                    <app-more-options-dropdown
                        [options]="moreOptions"
                        [isOpen]="isOpenOption && selectedIndex === i"
                        (toggle)="openMoreOption(i)"
                        (optionSelected)="onMoreOptionSelected(pattern, $event)"
                    ></app-more-options-dropdown>
                </div>
            </div>
            <div
                class="empty-state"
                *ngIf="!ledPatternList?.length"
            >
                {{ 'system-settings.eap.led.pattern-setting-dialog.empty' | translate }}
            </div>
        </div>
    </div>
</div>

<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'system-settings.eap.cancel.dialog.title'"
    [discardLabel]="'system-settings.eap.cancel.dialog.discard'"
    [goBackLabel]="'system-settings.eap.cancel.dialog.go-back'"
    [saveLabel]="'system-settings.eap.cancel.dialog.save'">
</app-confirmation-window>

<app-confirmation-window
    #deleteConfirmation
    class="delete-dialog"
    [mainLabel]="'system-settings.eap.led.pattern.delete-dialog.title'"
    [subLabel]="'system-settings.eap.led.pattern.delete-dialog.subLabel'"
    [discardLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.delete'"
    [allButtonsLeft]="true"
    [inverseColors]="true"
    [title]="deletePatternTitle">
</app-confirmation-window>
